<template>
	<div>
		<div class="exam-result">
			<div class="exam-result-main"><img src="@/assets/exam-result.webp" class="exam-result__img">
				<div class="exam-result__info">
					<div class="exam-result-info__name">
						<!-- <div style="background-color: #fff;margin-right: 10px;">
							<el-button style="background-color: #4c7bff;" type="primary" icon='el-icon-refresh'
								@click="reloadExam">重新考试</el-button>
						</div> -->
						<!-- <div style="background-color: #fff;margin-right: 10px;">
							<el-button style="background-color: #4c7bff;" type="primary" icon='el-icon-refresh'
								@click="toLogin">切换试卷</el-button>
						</div> -->
						<div>
							<span>考生姓名: {{ info.student_name }}</span>
							<span style="padding-left:10px;color:#1d52e6;" @click="toPrint">题解分析</span>
						</div>
					</div>
					<div class="exam-result-info__exam">考试科目: {{ info.exam_name }}</div>
				</div>
				<div class="exam-result__score">
					<!-- <div class="exam-result-score__item">
						<div class="exam-result-score-item__score">{{info.score_total}}</div>
						<div class="exam-result-score-item__title">得分</div>
					</div> -->
					<!-- <div class="exam-result-score__border"></div> -->
					<template v-for="(item, index) of info.score_arr">
						<div class="exam-result-score__item" :key="index">
							<div class="exam-result-score-item__score">{{ item.score }}</div>
							<div class="exam-result-score-item__title">{{ item.subject_name }}</div>
						</div>
						<div class="exam-result-score__border" v-if="index == 0"></div>
					</template>
					<div class="exam-result-score__border"></div>
					<div class="exam-result-score__item">
						<div class="exam-result-score-item__score">{{ info.score_total }}</div>
						<div class="exam-result-score-item__title">总分</div>
					</div>
				</div>
				<div class="exam-result__tips"><img src="@/assets/exam-result-tips.webp"
						class="exam-result-tips-background">
					<div class="exam-result-tips-content">{{ info.notice }}</div>
				</div>
			</div>
		</div>
		<!-- <PrintVue></PrintVue> -->
	</div>
</template>

<script>
	// import PrintVue from '../components/Print.vue';
	export default {
		// components: {
		// 	PrintVue
		// },
		computed: {
			pageData() {
				if (this.$store.state.pageData && this.$store.state.pageData.title) {
					document.title = this.$store.state.pageData.title;
				}
				return this.$store.state.pageData; // 访问Vuex Store的计数器状态
			},
		},
		name: 'result',
		data() {
			return {
				info: {}
			}
		},
		created() {
			this.getInfo();
		},
		methods: {
			getInfo() {
				this.$request.get('/sike.php/exam/getResultsV2').then((res) => {
					if (res.code == 200) {
						this.info = res.data;
					}
				})
			},
			toPrint() {
				this.$router.replace('/Print');
			},
			toLogin() {
				this.$router.push({
					path: '/Login',
					query: {
						type: 3
					}
				})
			},
			reloadExam() {
				this.$request.get('/sike.php/exam/reloadExam').then((res) => {
					if (res.code == 200) {
						this.$router.push({
							path: '/'
						})
						// this.info = res.data;
					}
				})
			}
		}
	}
</script>

<style scoped>
	.exam-result-main {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #fff;
		border-radius: .5rem
	}

	.exam-result-main .exam-result__img {
		width: 25rem;
		margin: 0 auto;
		-webkit-user-select: none;
		user-select: none;
		pointer-events: none
	}

	.exam-result-main .exam-result__info {
		margin-top: -1rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center
	}

	.exam-result-main .exam-result__info .exam-result-info__name {
		font-size: 1.56rem;
		font-family: PingFang SC-Bold;
		line-height: 1.83rem;
		display: flex;
		align-items: center;
	}

	.exam-result-main .exam-result__info .exam-result-info__exam {
		margin-top: 1.38rem;
		font-size: 1.56rem;
		font-family: PingFang SC-Bold;
		color: #a0a0a0;
		line-height: 1.83rem
	}

	.exam-result-main .exam-result__score {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 4rem
	}

	.exam-result-main .exam-result__score .exam-result-score__item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 22.63rem
	}

	.exam-result-main .exam-result__score .exam-result-score__item .exam-result-score-item__score {
		font-size: 2.5rem;
		font-family: PingFang SC-Bold;
		line-height: 2.93rem
	}

	.exam-result-main .exam-result__score .exam-result-score__item .exam-result-score-item__title {
		margin-top: 1.38rem;
		font-size: 1.88rem;
		font-family: PingFang SC-Bold;
		color: #a0a0a0;
		line-height: 2.2rem
	}

	.exam-result-main .exam-result__score .exam-result-score__border {
		height: 3.38rem;
		opacity: 1;
		border: .15rem solid #d7d7d7
	}

	.exam-result-main .exam-result__tips {
		width: 88rem;
		height: 4.94rem;
		margin-top: 4rem;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.exam-result-main .exam-result__tips .exam-result-tips-background {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		-webkit-user-select: none;
		user-select: none;
		pointer-events: none
	}

	.exam-result-main .exam-result__tips .exam-result-tips-content {
		font-size: 1.56rem;
		font-family: PingFang SC-Bold;
		color: #1d52e6;
		line-height: 1.83rem
	}

	.el-dialog {
		--el-dialog-width: 50%;
		--el-dialog-margin-top: 15vh;
		--el-dialog-bg-color: var(--el-bg-color);
		--el-dialog-box-shadow: var(--el-box-shadow);
		--el-dialog-title-font-size: var(--el-font-size-large);
		--el-dialog-content-font-size: 14px;
		--el-dialog-font-line-height: var(--el-font-line-height-primary);
		--el-dialog-padding-primary: 20px;
		--el-dialog-border-radius: var(--el-border-radius-small);
		position: relative;
		margin: var(--el-dialog-margin-top, 15vh) auto 50px;
		background: var(--el-dialog-bg-color);
		border-radius: var(--el-dialog-border-radius);
		box-shadow: var(--el-dialog-box-shadow);
		box-sizing: border-box;
		width: var(--el-dialog-width, 50%)
	}

	.el-dialog:focus {
		outline: 0 !important
	}

	.el-dialog.is-align-center {
		margin: auto
	}

	.el-dialog.is-fullscreen {
		--el-dialog-width: 100%;
		--el-dialog-margin-top: 0;
		margin-bottom: 0;
		height: 100%;
		overflow: auto
	}

	.el-dialog__wrapper {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0
	}

	.el-dialog.is-draggable .el-dialog__header {
		cursor: move;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}

	.el-dialog__header {
		padding: var(--el-dialog-padding-primary);
		padding-bottom: 10px;
		margin-right: 16px
	}

	.el-dialog__headerbtn {
		position: absolute;
		top: 6px;
		right: 0;
		padding: 0;
		width: 54px;
		height: 54px;
		background: 0 0;
		border: none;
		outline: 0;
		cursor: pointer;
		font-size: var(--el-message-close-size, 16px)
	}

	.el-dialog__headerbtn .el-dialog__close {
		color: var(--el-color-info);
		font-size: inherit
	}

	.el-dialog__headerbtn:focus .el-dialog__close,
	.el-dialog__headerbtn:hover .el-dialog__close {
		color: var(--el-color-primary)
	}

	.el-dialog__title {
		line-height: var(--el-dialog-font-line-height);
		font-size: var(--el-dialog-title-font-size);
		color: var(--el-text-color-primary)
	}

	.el-dialog__body {
		padding: calc(var(--el-dialog-padding-primary) + 10px) var(--el-dialog-padding-primary);
		color: var(--el-text-color-regular);
		font-size: var(--el-dialog-content-font-size)
	}

	.el-dialog__footer {
		padding: var(--el-dialog-padding-primary);
		padding-top: 10px;
		text-align: right;
		box-sizing: border-box
	}

	.el-dialog--center {
		text-align: center
	}

	.el-dialog--center .el-dialog__body {
		text-align: initial;
		padding: 25px calc(var(--el-dialog-padding-primary) + 5px) 30px
	}

	.el-dialog--center .el-dialog__footer {
		text-align: inherit
	}

	.el-overlay-dialog {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto
	}

	.dialog-fade-enter-active {
		-webkit-animation: modal-fade-in var(--el-transition-duration);
		animation: modal-fade-in var(--el-transition-duration)
	}

	.dialog-fade-enter-active .el-overlay-dialog {
		-webkit-animation: dialog-fade-in var(--el-transition-duration);
		animation: dialog-fade-in var(--el-transition-duration)
	}

	.dialog-fade-leave-active {
		-webkit-animation: modal-fade-out var(--el-transition-duration);
		animation: modal-fade-out var(--el-transition-duration)
	}

	.dialog-fade-leave-active .el-overlay-dialog {
		-webkit-animation: dialog-fade-out var(--el-transition-duration);
		animation: dialog-fade-out var(--el-transition-duration)
	}

	@-webkit-keyframes dialog-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes dialog-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@-webkit-keyframes dialog-fade-out {
		0% {
			transform: translateZ(0);
			opacity: 1
		}

		to {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}
	}

	@keyframes dialog-fade-out {
		0% {
			transform: translateZ(0);
			opacity: 1
		}

		to {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}
	}

	@-webkit-keyframes modal-fade-in {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	@keyframes modal-fade-in {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	@-webkit-keyframes modal-fade-out {
		0% {
			opacity: 1
		}

		to {
			opacity: 0
		}
	}

	@keyframes modal-fade-out {
		0% {
			opacity: 1
		}

		to {
			opacity: 0
		}
	}

	.el-overlay {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 2000;
		height: 100%;
		background-color: var(--el-overlay-color-lighter);
		overflow: auto
	}

	.el-overlay .el-overlay-root {
		height: 0
	}

	.el-image__error,
	.el-image__inner,
	.el-image__placeholder,
	.el-image__wrapper {
		width: 100%;
		height: 100%
	}

	.el-image {
		position: relative;
		display: inline-block;
		overflow: hidden
	}

	.el-image__inner {
		vertical-align: top;
		opacity: 1
	}

	.el-image__inner.is-loading {
		opacity: 0
	}

	.el-image__wrapper {
		position: absolute;
		top: 0;
		left: 0
	}

	.el-image__placeholder {
		background: var(--el-fill-color-light)
	}

	.el-image__error {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		background: var(--el-fill-color-light);
		color: var(--el-text-color-placeholder);
		vertical-align: middle
	}

	.el-image__preview {
		cursor: pointer
	}

	.el-image-viewer__wrapper {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0
	}

	.el-image-viewer__btn {
		position: absolute;
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		opacity: .8;
		cursor: pointer;
		box-sizing: border-box;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}

	.el-image-viewer__btn .el-icon {
		font-size: inherit;
		cursor: pointer
	}

	.el-image-viewer__close {
		top: 40px;
		right: 40px;
		width: 40px;
		height: 40px;
		font-size: 40px
	}

	.el-image-viewer__canvas {
		position: static;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}

	.el-image-viewer__actions {
		left: 50%;
		bottom: 30px;
		transform: translate(-50%);
		width: 282px;
		height: 44px;
		padding: 0 23px;
		background-color: var(--el-text-color-regular);
		border-color: #fff;
		border-radius: 22px
	}

	.el-image-viewer__actions__inner {
		width: 100%;
		height: 100%;
		cursor: default;
		font-size: 23px;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-around
	}

	.el-image-viewer__prev {
		top: 50%;
		transform: translateY(-50%);
		left: 40px;
		width: 44px;
		height: 44px;
		font-size: 24px;
		color: #fff;
		background-color: var(--el-text-color-regular);
		border-color: #fff
	}

	.el-image-viewer__next {
		top: 50%;
		transform: translateY(-50%);
		right: 40px;
		text-indent: 2px;
		width: 44px;
		height: 44px;
		font-size: 24px;
		color: #fff;
		background-color: var(--el-text-color-regular);
		border-color: #fff
	}

	.el-image-viewer__close {
		width: 44px;
		height: 44px;
		font-size: 24px;
		color: #fff;
		background-color: var(--el-text-color-regular);
		border-color: #fff
	}

	.el-image-viewer__mask {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: .5;
		background: #000
	}

	.viewer-fade-enter-active {
		-webkit-animation: viewer-fade-in var(--el-transition-duration);
		animation: viewer-fade-in var(--el-transition-duration)
	}

	.viewer-fade-leave-active {
		-webkit-animation: viewer-fade-out var(--el-transition-duration);
		animation: viewer-fade-out var(--el-transition-duration)
	}

	@-webkit-keyframes viewer-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes viewer-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@-webkit-keyframes viewer-fade-out {
		0% {
			transform: translateZ(0);
			opacity: 1
		}

		to {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}
	}

	@keyframes viewer-fade-out {
		0% {
			transform: translateZ(0);
			opacity: 1
		}

		to {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}
	}

	.el-skeleton {
		--el-skeleton-color: var(--el-fill-color);
		--el-skeleton-to-color: var(--el-fill-color-darker)
	}

	@-webkit-keyframes el-skeleton-loading {
		0% {
			background-position: 100% 50%
		}

		to {
			background-position: 0 50%
		}
	}

	@keyframes el-skeleton-loading {
		0% {
			background-position: 100% 50%
		}

		to {
			background-position: 0 50%
		}
	}

	.el-skeleton {
		width: 100%
	}

	.el-skeleton__first-line,
	.el-skeleton__paragraph {
		height: 16px;
		margin-top: 16px;
		background: var(--el-skeleton-color)
	}

	.el-skeleton.is-animated .el-skeleton__item {
		background: linear-gradient(90deg, var(--el-skeleton-color) 25%, var(--el-skeleton-to-color) 37%, var(--el-skeleton-color) 63%);
		background-size: 400% 100%;
		-webkit-animation: el-skeleton-loading 1.4s ease infinite;
		animation: el-skeleton-loading 1.4s ease infinite
	}

	.el-skeleton {
		--el-skeleton-circle-size: var(--el-avatar-size)
	}

	.el-skeleton__item {
		background: var(--el-skeleton-color);
		display: inline-block;
		height: 16px;
		border-radius: var(--el-border-radius-base);
		width: 100%
	}

	.el-skeleton__circle {
		border-radius: 50%;
		width: var(--el-skeleton-circle-size);
		height: var(--el-skeleton-circle-size);
		line-height: var(--el-skeleton-circle-size)
	}

	.el-skeleton__button {
		height: 40px;
		width: 64px;
		border-radius: 4px
	}

	.el-skeleton__p {
		width: 100%
	}

	.el-skeleton__p.is-last {
		width: 61%
	}

	.el-skeleton__p.is-first {
		width: 33%
	}

	.el-skeleton__text {
		width: 100%;
		height: var(--el-font-size-small)
	}

	.el-skeleton__caption {
		height: var(--el-font-size-extra-small)
	}

	.el-skeleton__h1 {
		height: var(--el-font-size-extra-large)
	}

	.el-skeleton__h3 {
		height: var(--el-font-size-large)
	}

	.el-skeleton__h5 {
		height: var(--el-font-size-medium)
	}

	.el-skeleton__image {
		width: unset;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 0
	}

	.el-skeleton__image svg {
		color: var(--el-svg-monochrome-grey);
		fill: currentColor;
		width: 22%;
		height: 22%
	}

	.answering-area[data-v-96979eaa] {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		overflow-y: auto
	}

	.answering-area .question-img[data-v-96979eaa] {
		width: 92.13rem;
		height: auto;
		-webkit-user-select: none;
		user-select: none;
		pointer-events: none;
		margin: 0 auto
	}

	.answering-area .answering[data-v-96979eaa] {
		box-sizing: border-box;
		margin-top: 3rem;
		width: 100%;
		padding: 0 28.88rem;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		column-gap: 4.38rem;
		row-gap: 4.38rem
	}

	.answering-area .answering .answering-choice[data-v-96979eaa] {
		box-sizing: border-box;
		width: 6.25rem;
		height: 6.25rem;
		background: #f4f4f4;
		border-radius: .31rem;
		font-size: 2.5rem;
		font-family: PingFang SC-Bold;
		color: #c6c6c6;
		line-height: 2.93rem;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: .2s all;
		-webkit-user-select: none;
		user-select: none;
		border: .13rem solid #f4f4f4;
		cursor: pointer
	}

	.answering-area .answering .answering-choice[data-v-96979eaa]:hover {
		transition: .2s all;
		box-shadow: 0 2px 10px 3px #0000001a
	}

	.answering-area .answering .answering-choice_active[data-v-96979eaa] {
		background: #4c7bff;
		border: .13rem solid #0936b6;
		color: #fff
	}

	.answering-area .pre-next[data-v-96979eaa] {
		box-sizing: border-box;
		margin-top: 4rem;
		width: 100%;
		padding: 0 34.38rem;
		display: flex;
		align-items: center;
		justify-content: space-around
	}

	.answering-area .pre-next .pre-next-button[data-v-96979eaa] {
		width: 11rem;
		height: 3.5rem;
		border-radius: .31rem;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		line-height: 1.46rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.answering-area .pre-next .pre-next-button[data-v-96979eaa]:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 3px #0000004d
	}

	.answering-area .pre-next .pre-button[data-v-96979eaa] {
		border: .13rem solid #828282;
		color: #828282
	}

	.answering-area .pre-next .next-button[data-v-96979eaa] {
		background: #4c7bff;
		color: #fff
	}

	:root {
		--el-popup-modal-bg-color: var(--el-color-black);
		--el-popup-modal-opacity: .5
	}

	.v-modal-enter {
		-webkit-animation: v-modal-in var(--el-transition-duration-fast) ease;
		animation: v-modal-in var(--el-transition-duration-fast) ease
	}

	.v-modal-leave {
		-webkit-animation: v-modal-out var(--el-transition-duration-fast) ease forwards;
		animation: v-modal-out var(--el-transition-duration-fast) ease forwards
	}

	@-webkit-keyframes v-modal-in {
		0% {
			opacity: 0
		}
	}

	@keyframes v-modal-in {
		0% {
			opacity: 0
		}
	}

	@-webkit-keyframes v-modal-out {
		to {
			opacity: 0
		}
	}

	@keyframes v-modal-out {
		to {
			opacity: 0
		}
	}

	.v-modal {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		opacity: var(--el-popup-modal-opacity);
		background: var(--el-popup-modal-bg-color)
	}

	.el-popup-parent--hidden {
		overflow: hidden
	}

	.el-message-box {
		--el-messagebox-title-color: var(--el-text-color-primary);
		--el-messagebox-width: 420px;
		--el-messagebox-border-radius: 4px;
		--el-messagebox-font-size: var(--el-font-size-large);
		--el-messagebox-content-font-size: var(--el-font-size-base);
		--el-messagebox-content-color: var(--el-text-color-regular);
		--el-messagebox-error-font-size: 12px;
		--el-messagebox-padding-primary: 15px
	}

	.el-message-box {
		display: inline-block;
		max-width: var(--el-messagebox-width);
		width: 100%;
		padding-bottom: 10px;
		vertical-align: middle;
		background-color: var(--el-bg-color);
		border-radius: var(--el-messagebox-border-radius);
		border: 1px solid var(--el-border-color-lighter);
		font-size: var(--el-messagebox-font-size);
		box-shadow: var(--el-box-shadow-light);
		text-align: left;
		overflow: hidden;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		box-sizing: border-box
	}

	.el-message-box:focus {
		outline: 0 !important
	}

	.el-overlay.is-message-box .el-overlay-message-box {
		text-align: center;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		padding: 16px;
		overflow: auto
	}

	.el-overlay.is-message-box .el-overlay-message-box:after {
		content: "";
		display: inline-block;
		height: 100%;
		width: 0;
		vertical-align: middle
	}

	.el-message-box.is-draggable .el-message-box__header {
		cursor: move;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}

	.el-message-box__header {
		position: relative;
		padding: var(--el-messagebox-padding-primary);
		padding-bottom: 10px
	}

	.el-message-box__title {
		padding-left: 0;
		margin-bottom: 0;
		font-size: var(--el-messagebox-font-size);
		line-height: 1;
		color: var(--el-messagebox-title-color)
	}

	.el-message-box__headerbtn {
		position: absolute;
		top: var(--el-messagebox-padding-primary);
		right: var(--el-messagebox-padding-primary);
		padding: 0;
		border: none;
		outline: 0;
		background: 0 0;
		font-size: var(--el-message-close-size, 16px);
		cursor: pointer
	}

	.el-message-box__headerbtn .el-message-box__close {
		color: var(--el-color-info);
		font-size: inherit
	}

	.el-message-box__headerbtn:focus .el-message-box__close,
	.el-message-box__headerbtn:hover .el-message-box__close {
		color: var(--el-color-primary)
	}

	.el-message-box__content {
		padding: 10px var(--el-messagebox-padding-primary);
		color: var(--el-messagebox-content-color);
		font-size: var(--el-messagebox-content-font-size)
	}

	.el-message-box__container {
		position: relative
	}

	.el-message-box__input {
		padding-top: 15px
	}

	.el-message-box__input div.invalid>input {
		border-color: var(--el-color-error)
	}

	.el-message-box__input div.invalid>input:focus {
		border-color: var(--el-color-error)
	}

	.el-message-box__status {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		font-size: 24px !important
	}

	.el-message-box__status:before {
		padding-left: 1px
	}

	.el-message-box__status.el-icon {
		position: absolute
	}

	.el-message-box__status+.el-message-box__message {
		padding-left: 36px;
		padding-right: 12px;
		overflow-wrap: break-word
	}

	.el-message-box__status.el-message-box-icon--success {
		--el-messagebox-color: var(--el-color-success);
		color: var(--el-messagebox-color)
	}

	.el-message-box__status.el-message-box-icon--info {
		--el-messagebox-color: var(--el-color-info);
		color: var(--el-messagebox-color)
	}

	.el-message-box__status.el-message-box-icon--warning {
		--el-messagebox-color: var(--el-color-warning);
		color: var(--el-messagebox-color)
	}

	.el-message-box__status.el-message-box-icon--error {
		--el-messagebox-color: var(--el-color-error);
		color: var(--el-messagebox-color)
	}

	.el-message-box__message {
		margin: 0
	}

	.el-message-box__message p {
		margin: 0;
		line-height: 24px
	}

	.el-message-box__errormsg {
		color: var(--el-color-error);
		font-size: var(--el-messagebox-error-font-size);
		min-height: 18px;
		margin-top: 2px
	}

	.el-message-box__btns {
		padding: 5px 15px 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: center
	}

	.el-message-box__btns button:nth-child(2) {
		margin-left: 10px
	}

	.el-message-box__btns-reverse {
		flex-direction: row-reverse
	}

	.el-message-box--center .el-message-box__title {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.el-message-box--center .el-message-box__status {
		position: relative;
		top: auto;
		padding-right: 5px;
		text-align: center;
		transform: translateY(-1px)
	}

	.el-message-box--center .el-message-box__message {
		margin-left: 0
	}

	.el-message-box--center .el-message-box__btns {
		justify-content: center
	}

	.el-message-box--center .el-message-box__content {
		padding-left: calc(var(--el-messagebox-padding-primary) + 12px);
		padding-right: calc(var(--el-messagebox-padding-primary) + 12px);
		text-align: center
	}

	.fade-in-linear-enter-active .el-overlay-message-box {
		-webkit-animation: msgbox-fade-in var(--el-transition-duration);
		animation: msgbox-fade-in var(--el-transition-duration)
	}

	.fade-in-linear-leave-active .el-overlay-message-box {
		animation: msgbox-fade-in var(--el-transition-duration) reverse
	}

	@-webkit-keyframes msgbox-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes msgbox-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	.question-list-area[data-v-f176a0f1] {
		box-sizing: border-box;
		padding: 1.88rem 1.88rem .2rem;
		overflow-y: auto;
		height: calc(100% - 5.38rem)
	}

	.question-list-area .question-grid[data-v-f176a0f1] {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		column-gap: .88rem;
		row-gap: .88rem
	}

	.question-list-area .question-grid .question-card[data-v-f176a0f1] {
		width: 2.81rem;
		height: 2.81rem;
		background: #f7f7f7;
		border-radius: .31rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #c3c3c3;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.question-list-area .question-grid .question-card[data-v-f176a0f1]:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 1px #0000001a
	}

	.question-list-area .question-grid .question-card_done[data-v-f176a0f1] {
		background: #4c7bff;
		color: #fff
	}

	.question-list-area .question-grid .question-card_active[data-v-f176a0f1] {
		background: #e6a23c;
		color: #fff;
	}

	.sumit-button[data-v-f176a0f1] {
		width: 17.56rem;
		height: 3.5rem;
		background: #4c7bff;
		border-radius: .31rem;
		margin: 0 auto;
		margin-top: 1.2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #fff;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.sumit-button[data-v-f176a0f1]:hover {
		transition: .2s all;
		box-shadow: 0 3px 5px 1px #0003
	}

	.timer[data-v-b4e914a4] {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%
	}

	.timer .timer-icon[data-v-b4e914a4] {
		width: 1.5rem;
		margin-right: 1rem
	}

	.timer .timer-text[data-v-b4e914a4] {
		font-size: 1.56rem;
		font-family: PingFang SC-Bold;
		color: red;
		line-height: 1.83rem
	}

	.exam {
		height: 100%;
		width: 100%
	}

	.exam .left-side {
		position: absolute;
		top: .94rem;
		left: .94rem;
		height: 100%;
		width: 21.31rem;
		transform: translate(0);
		overflow-y: auto
	}

	.exam .left-side .timer {
		width: 100%;
		height: 4.19rem;
		background: #fff;
		border-radius: .5rem;
		opacity: 1
	}

	.exam .left-side .question-list {
		margin-top: .94rem;
		width: 100%;
		height: calc(100% - 6.07rem);
		background: #fff;
		border-radius: .5rem;
		opacity: 1
	}

	.exam .answer-area {
		position: absolute;
		top: .94rem;
		left: 23.19rem;
		width: 95.88rem;
		border-radius: .5rem;
		height: calc(100% - .94rem);
		background-color: #fff
	}

	.exam-start-info .exam-start-info__item {
		margin-bottom: 2rem;
		display: flex
	}

	.exam-start-info .exam-start-info__item .exam-start-info-item__title {
		font-size: 1.5rem;
		font-family: PingFang SC-Bold;
		color: #333;
		min-width: 6rem
	}

	.exam-start-info .exam-start-info__item .exam-start-info-item__content {
		margin-left: 1rem;
		font-size: 1.25rem;
		font-family: PingFang SC-Regular;
		color: #666;
		line-height: 2rem
	}

	.exam-start-info .start-button {
		width: 17.56rem;
		height: 3.5rem;
		background: #4c7bff;
		border-radius: .31rem;
		margin: 0 auto;
		margin-top: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #fff;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.exam-start-info .start-button:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 1px #0006
	}

	.exam-result {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .94rem .94rem 0
	}
</style>